import { ANALYTICS_PUSH, COOKIE_CONFIG } from '../constants/ActionTypes';

export const analyticsPush = (payload, eventType) => ({
	type: eventType ? `${ANALYTICS_PUSH}_${eventType}` : ANALYTICS_PUSH,
	payload,
});

export const fetchCookieConfig = () => (dispatch) =>
	dispatch({
		type: COOKIE_CONFIG,
		payload: {
			client: 'basic',
			url: 'https://cookiewet.rtl.nl/data/settings.json',
			method: 'GET',
		},
	});
